import { httpClient } from '@shared/api';
import type { User } from '../model/types';

export const userApi = {
  /**
   * Получить текущего юзера (по cookies access_token).
   * include=assistants подгружает ассистентов в одном запросе —
   * нужно для отрисовки сайдбара сразу после логина.
   */
  async getMe(): Promise<User> {
    const response = await httpClient.get<User>('/user/', {
      params: { include: 'assistants' },
    });
    return response.data;
  },

  async deleteMe(): Promise<void> {
    await httpClient.delete('/user/');
  },
};
